<template>
    <b-button
        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        variant="primary"
        class="btn-icon"
        @click="click"
    >
        <feather-icon icon="ColumnsIcon" />
    </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
export default {
    components: {
        BButton
    },
    directives: {
        Ripple,
    },
    methods: {
        click() {
            this.$emit('click')
        }
    }
}
</script>
